import { j as r, c as t } from "./utils-BdNIfrGQ.js";
import { n as c } from "./normalize-spacing-DY0KSpr_.js";
const i = ({
  children: s,
  spacing: a,
  className: o,
  ...n
}) => /* @__PURE__ */ r.jsx("section", { className: t(o, c(a)), ...n, children: s });
export {
  i as S
};
